var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 83,
    viewBox: "0 0 93 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3721 20.2512V21.5708",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0415 22.1296H70.9409",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8823 22.1296H68.7817",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3721 22.7693V24.0888",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8457 58.0225V59.342",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51512 59.9009H4.41455",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35595 59.9009H2.25537",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8457 60.5405V61.8601",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59229 23.7546V25.0742",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25975 25.6331H3.15918",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10057 25.6331H1",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59229 26.2727V27.5922",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7358 1V2.31954",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4052 2.87842H41.3027",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2461 2.87842H39.1436",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7358 3.51807V4.8376",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6989 34.8527V23.4475L37.7894 6.18018L7.87988 23.4475V57.984L37.24 74.677",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87988 23.4475L37.24 39.0707L67.6989 23.4475",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2397 39.0706V74.6769",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88184 35.9302L29.2748 46.7419V56.6106L7.92025 44.704L7.88184 35.9302Z",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2324 16.4023L50.8404 32.1215",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1791 82.5136L83.4389 70.5974V46.767L62.8008 34.8528L42.1626 46.767V73.1827L56.8388 81.2229",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4389 46.7668L63.1791 57.5479L42.1626 46.7668",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1792 57.5481V82.5137",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M83.437 55.3794L68.6763 62.8395V69.6504L83.4101 61.4335L83.437 55.3794Z",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2252 41.9055L53.7944 52.7518",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51514 77.1719H43.8489",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51514 82.5134H59.2762",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9189 77.1719H91.8077",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9409 82.5134H91.8076",
    stroke: "#005555",
    strokeWidth: 0.87,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.f8ea7bf753747fa548477e6a4e3e4eb2.svg";
export { ForwardRef as ReactComponent };